export default "<checkout-profile-user [isNew]=\"isNew\" [profileType]=\"profileUsers.Bank\"></checkout-profile-user>"